import { Component, OnInit, Type } from '@angular/core';
import { CloudDlgManagerService } from '../../../services/cloud-storage/cloud-dlg-manager.service';
import { MimeTypesEnum } from '../../../utils/enums';
import { CloudData } from '../../../services/cloud-storage/metadata/CloudData';
import { FileCopyInfo } from '../../../services/cloud-storage/models/file-copy-info';
import { Breadcrumb } from '../../../utils/interfaces/breadcrumb.interface';
import { IGetClass, IModalWindow } from '../../../utils/interfaces/modal-dialog.interface';
import { ModalWindowsTypes } from '../../../core/enums';
import { SettingsService } from '../../../services/settings/settings.service';
import { FileCopyService } from '../../../services/file-copy.service';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CurrentDialogEnum } from 'src/app/utils/enums/current-dialog.enum';
import { BaseFileBrowserComponent } from '../../base-file-browser/base-file-browser.component';
import { CloudSettingsService } from 'src/app/services/cloud-settings.service';
import { CloudFoldersEnum } from 'src/app/utils/enums/cloud-folders.enum';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipDirective } from '../../../utils/directives/tooltip.directive';
import { PureSpinnerComponent } from '../../pure-spinner/pure-spinner.component';

import { BreadcrumbsComponent } from '../../breadcrumbs/breadcrumbs.component';

@Component({
    selector: 'asg-file-move-dialog',
    templateUrl: './file-move-dialog.component.html',
    styleUrls: ['./file-move-dialog.component.scss'],
    standalone: true,
    imports: [BreadcrumbsComponent, FormsModule, ReactiveFormsModule, PureSpinnerComponent, TooltipDirective, TranslateModule]
})
export class FileMoveDialogComponent extends BaseFileBrowserComponent implements OnInit, IModalWindow, IGetClass {
  isCopy: boolean = false;
  breadcrumbs: Array<Breadcrumb>;
  private folderToCopy: CloudData | null;

  get cloudFolders() {
    return this.folders.filter(f => f !== CloudFoldersEnum.Recent);
  }

  constructor(
    cloudManager: CloudDlgManagerService,
    settingsService: SettingsService,
    formBuilder: FormBuilder,
    dialog: MatDialog,
    cloudSettingsService: CloudSettingsService,
    private fileCopySvc: FileCopyService
  ) {
    super(cloudManager, settingsService, formBuilder, dialog, cloudSettingsService);
  }

  ngOnInit(): void {
    this.dialogStatus.set(this.cloudManager.getPickerStatus());
    this.breadcrumbs = [];
    this.isCopy = this.fileCopySvc.copyInfo.copy;
    super.ngOnInit();
  }

  getClass(): string {
    return 'file-move-dlg';
  }

  getWindowType(): Type<IModalWindow> {
    return FileMoveDialogComponent;
  }

  getWindowEnumType(): ModalWindowsTypes {
    return ModalWindowsTypes.FILE_MOVE_DIALOG;
  }

  getInstanceOf(type: string): IModalWindow | IGetClass | null {
    switch (type) {
      case 'IModalWindow':
        return this as unknown as IModalWindow;
      case 'IGetClass':
        return this as unknown as IGetClass;
      default: return null;
    }
  }

  singleClick(evt: Event): void {
    if (this.selectedItem &&
      (this.selectedItem.mimeType === MimeTypesEnum.Folder || this.selectedItem.mimeType === MimeTypesEnum.DriveFolder || 
        this.selectedItem.mimeType === MimeTypesEnum.SharedDrive)) {
      this.toggleActive(evt);
      this.folderToCopy = this.selectedItem;

      if (this.fileCopySvc.copyInfo) {
        const parent: Partial<FileCopyInfo> = {
          parentToCopy: this.selectedItem,
        };

        this.fileCopySvc.setFileCopyInfo(parent);
      }
    }
  }

  returnToCloudStorage(): void {
    this.cloudManager.showComponent(CurrentDialogEnum.CloudStorageDlg);
  }

  async pasteFile(): Promise<void> {
    await this.cloudManager.copyOrMoveFile(this.fileCopySvc.copyInfo);
    this.fileCopySvc.clear();
    this.fileList = await this.getFileList();

    if (this.folderToCopy) {
      this.cloudManager.addfolderToHistory(this.folderToCopy);
      this.folderToCopy = null;
    }

    this.returnToCloudStorage();
  }
}
